<template>
    <div>
      <div style="margin-bottom: 20px;">
        From Full Text <el-switch v-model="is_from_components"></el-switch> From Components
      </div>
      <div v-if="is_from_components">
        <el-select v-model="selected_component_type">
          <el-option
              v-for="component_type in component_types"
              :key = "component_type.id"
              :label = "component_type.name"
              :value = "component_type.id">
          </el-option>
        </el-select>
      </div>
      <div v-else>
        <p>If nothing is entered below, Content Chimera will consider the first &lt;article&gt; tag as the content. Otherwise, enter the CSS ID(s) or CSS class(es) that include the actual content of a page. NOTE: text analysis success is highly dependent on finding the actual content!</p>
        <el-input v-model="xpath_to_include" placeholder="XPath to include"></el-input>
        <el-input v-model="ids_to_include" placeholder="IDs to include"></el-input>
        <el-input v-model="classes_to_include" placeholder="Classes to include"></el-input>
      </div>
      <hr />
      <el-checkbox v-model="analyze_duplicates">Analyze Duplicates</el-checkbox>
      <el-checkbox v-model="reading_level">Run Reading Level Analysis</el-checkbox>
      <el-checkbox v-if="show_bleeding_edge" v-model="analyze_nlp">Run Natural Language Processing</el-checkbox>
      <el-checkbox v-model="run_llm">Run LLM Prompts</el-checkbox>
      <div v-if="run_llm">
        <el-select v-model="selected_llm_fieldset" placeholder="Select Fieldset" style="margin-top: 10px; margin-bottom: 10px; width: 100%;">
          <el-option
            v-for="fieldset in llm_fieldsets"
            :key="fieldset.id"
            :label="fieldset.name"
            :value="fieldset.id">
          </el-option>
        </el-select>
        <el-select v-model="selected_sampling_definition" placeholder="Select Sampling Definition" style="margin-bottom: 10px; width: 100%;">
          <el-option
            v-for="definition in sampling_definitions"
            :key="definition.id"
            :label="definition.name"
            :value="definition.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-checkbox v-model="count_words">Count Words</el-checkbox>
      </div>
      <el-checkbox v-model="analyze_words">Run Word Frequency Analysis</el-checkbox>
      <div v-if="analyze_words">
        <el-input v-model="word_cloud_category_field" placeholder="Category Field (optional)"></el-input>
      </div>
      <el-button type="primary" style="margin-top:20px" v-on:click="startAnalysis">Start Analysis</el-button>
    </div>
</template>

<script>

    export default {
        props: ['selected_extent'],

        mounted() {
          if (chimera.permissions.includes('BLEEDING_EDGE')) this.show_bleeding_edge = true
          console.log('components')
          this.getComponentTypes()
          this.getLlmFieldsets()
          this.getSamplingDefinitions()
        },
        watch: {
            selected_extent: function() {
              console.log('watcher')
              this.getComponentTypes()
              this.getLlmFieldsets()
              this.getSamplingDefinitions()
            }
        },
        data() {
            return {
                xpath_to_include: null,
                ids_to_include: null,
                classes_to_include: null,
                reading_level: false,
                analyze_duplicates: true,
                analyze_nlp: false,
                analyze_words: false,
                count_words: true,
                run_llm: false,
                word_cloud_category_field: '',
                show_bleeding_edge: false,
                is_from_components: false,
                component_types: [],
                selected_component_type: null,
                llm_fieldsets: [],
                sampling_definitions: [],
                selected_llm_fieldset: null,
                selected_sampling_definition: null,
            }
        },
        methods: {
            getComponentTypes() {
              if (this.selected_extent) {
                axios.get('/component_types_list/' + this.selected_extent)
                    .then(response => {
                      this.component_types = response.data
                    })
                    .catch(error => {
                      console.log('oops getting component types')
                    })
              }
            },
            getLlmFieldsets() {
              if (this.selected_extent) {
                axios.get('/api/llm/fieldset/extent/' + this.selected_extent)
                    .then(response => {
                      this.llm_fieldsets = response.data
                      // Pre-select if there's only one option
                      if (this.llm_fieldsets.length === 1) {
                        this.selected_llm_fieldset = this.llm_fieldsets[0].id
                      } else {
                        this.selected_llm_fieldset = null
                      }
                    })
                    .catch(error => {
                      console.log('Error getting LLM fieldsets:', error)
                    })
              }
            },
            getSamplingDefinitions() {
              if (this.selected_extent) {
                axios.get('/api/sampling/extent/' + this.selected_extent)
                    .then(response => {
                      this.sampling_definitions = response.data
                      // Pre-select if there's only one option
                      if (this.sampling_definitions.length === 1) {
                        this.selected_sampling_definition = this.sampling_definitions[0].id
                      } else {
                        this.selected_sampling_definition = null
                      }
                    })
                    .catch(error => {
                      console.log('Error getting sampling definitions:', error)
                    })
              }
            },
            startAnalysis() {
                axios.post('/api/jobChains', {
                    extent_id: this.selected_extent,
                    type: 'ROT',
                    xpath_to_include: this.xpath_to_include,
                    ids_to_include: this.ids_to_include,
                    classes_to_include: this.classes_to_include,
                    reading_level: this.reading_level,
                    analyze_duplicates: this.analyze_duplicates,
                    analyze_nlp: this.analyze_nlp,
                    analyze_words: this.analyze_words,
                    run_llm: this.run_llm,
                    count_words: this.count_words,
                    word_cloud_category_field: this.word_cloud_category_field,
                    component_type_id: this.selected_component_type,
                    llm_prompt_fieldset_id: this.run_llm ? this.selected_llm_fieldset : null,
                    sampling_definition_id: this.run_llm ? this.selected_sampling_definition : null,
                }).then(response => {
                    window.location.href = '/progress/' + response.data.job_chain_id
                }).catch(error => {
                    console.log('oops problem starting import')
                    console.log(error.response)
                })
            }
        }
    }
</script>
